"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Sections_exports = {};
__export(Sections_exports, {
  default: () => Sections_default
});
module.exports = __toCommonJS(Sections_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.2031 8.58984C11.5547 8.58984 11.8672 8.6875 12.1406 8.88281C12.4271 9.0651 12.6354 9.31901 12.7656 9.64453L12.8633 9.9375L13.0781 10.4844C13.0911 10.5234 13.1042 10.569 13.1172 10.6211C13.1432 10.6602 13.1628 10.6992 13.1758 10.7383L13.293 11.0898H18C18.2083 11.0898 18.3906 11.1615 18.5469 11.3047C18.7161 11.4349 18.8073 11.6042 18.8203 11.8125L18.8398 11.9102V12.75C18.8398 12.9844 18.7552 13.1862 18.5859 13.3555C18.4297 13.5117 18.2344 13.5898 18 13.5898H17.6484L17.9609 17.9648V18.0039C17.9609 18.1602 17.9023 18.2969 17.7852 18.4141C17.668 18.5312 17.5312 18.5898 17.375 18.5898C17.1927 18.5898 17.0365 18.5312 16.9062 18.4141C16.7891 18.2839 16.724 18.1341 16.7109 17.9648L16.3984 13.5898H13.8594V13.6484C13.8724 13.7656 13.8789 13.8893 13.8789 14.0195C13.8919 14.1367 13.8984 14.2604 13.8984 14.3906C13.8984 14.7812 13.7812 15.1263 13.5469 15.4258C13.3255 15.7253 13.0391 15.9206 12.6875 16.0117L12.9219 17.9648V18.0234C12.9219 18.1797 12.8698 18.3164 12.7656 18.4336C12.6615 18.5378 12.5312 18.5898 12.375 18.5898C12.1927 18.5898 12.0365 18.5312 11.9062 18.4141C11.776 18.2969 11.6979 18.1471 11.6719 17.9648L11.4375 16.0898H9.5625L9.32812 17.9648C9.30208 18.1471 9.22396 18.2969 9.09375 18.4141C8.96354 18.5312 8.80729 18.5898 8.625 18.5898C8.46875 18.5898 8.33854 18.5378 8.23438 18.4336C8.13021 18.3164 8.07812 18.1797 8.07812 18.0234V17.9648L8.3125 16.0117C7.98698 15.9206 7.70703 15.7448 7.47266 15.4844C7.2513 15.2109 7.1276 14.8984 7.10156 14.5469V14.3906C7.10156 14.2474 7.10156 14.1107 7.10156 13.9805C7.11458 13.8503 7.1276 13.7201 7.14062 13.5898H4.60156L4.28906 17.9648C4.27604 18.1341 4.20443 18.2839 4.07422 18.4141C3.95703 18.5312 3.80729 18.5898 3.625 18.5898C3.46875 18.5898 3.33203 18.5312 3.21484 18.4141C3.09766 18.2969 3.03906 18.1602 3.03906 18.0039V17.9648L3.35156 13.5898H3C2.76562 13.5898 2.5638 13.5117 2.39453 13.3555C2.23828 13.1862 2.16016 12.9844 2.16016 12.75V11.9102C2.16016 11.6888 2.23828 11.5 2.39453 11.3438C2.5638 11.1745 2.76562 11.0898 3 11.0898H7.70703C7.72005 11.0378 7.73307 10.9857 7.74609 10.9336C7.77214 10.8815 7.79167 10.8294 7.80469 10.7773L8 10.2305C8.03906 10.1393 8.07812 10.0417 8.11719 9.9375C8.15625 9.83333 8.19531 9.73568 8.23438 9.64453C8.36458 9.31901 8.56641 9.0651 8.83984 8.88281C9.1263 8.6875 9.4388 8.58984 9.77734 8.58984H11.2031ZM11.2031 9.41016H9.77734C9.60807 9.41016 9.45182 9.46224 9.30859 9.56641C9.17839 9.65755 9.08073 9.78125 9.01562 9.9375L8.89844 10.2305L8.70312 10.7773C8.49479 11.3372 8.33203 11.832 8.21484 12.2617C8.09766 12.6784 8.02604 13.0299 8 13.3164V13.5898H7.98047L7.96094 13.707C7.96094 13.7591 7.96094 13.8177 7.96094 13.8828C7.96094 13.9349 7.95443 13.987 7.94141 14.0391V14.4102C7.94141 14.6315 8.01302 14.8203 8.15625 14.9766C8.29948 15.1328 8.47526 15.224 8.68359 15.25H8.78125H12.2383C12.4727 15.25 12.668 15.1654 12.8242 14.9961C12.9805 14.8268 13.0586 14.6315 13.0586 14.4102C13.0586 14.2669 13.0521 14.1302 13.0391 14C13.0391 13.8568 13.0326 13.7201 13.0195 13.5898H13V13.3164L12.9805 13.1992C12.9674 13.056 12.9349 12.8932 12.8828 12.7109C12.8438 12.5286 12.7917 12.3203 12.7266 12.0859L12.6094 11.6758C12.5964 11.6497 12.5833 11.6172 12.5703 11.5781C12.5573 11.5391 12.5443 11.5 12.5312 11.4609L12.375 10.9922L12.1992 10.4844L11.9844 9.9375C11.9193 9.78125 11.8151 9.65755 11.6719 9.56641C11.5286 9.46224 11.3724 9.41016 11.2031 9.41016ZM7.16016 11.9102H3V12.75H7.16016V11.9102ZM18 11.9102H13.8398V12.75H18V11.9102ZM17.3359 1.91016C17.5182 1.91016 17.6745 1.99479 17.8047 2.16406C17.9349 2.32031 18 2.51562 18 2.75V6.91016H18.4883C18.5794 6.91016 18.651 6.92969 18.7031 6.96875C18.7682 6.99479 18.8073 7.03385 18.8203 7.08594L18.8398 7.125V7.53516C18.8398 7.60026 18.8073 7.65234 18.7422 7.69141C18.6771 7.73047 18.5924 7.75 18.4883 7.75H8.33203C8.24089 7.75 8.16276 7.73047 8.09766 7.69141C8.03255 7.65234 8 7.60026 8 7.53516V7.125C8 7.07292 8.03255 7.02734 8.09766 6.98828C8.16276 6.9362 8.24089 6.91016 8.33203 6.91016H8.83984V2.75C8.83984 2.51562 8.89844 2.32031 9.01562 2.16406C9.14583 1.99479 9.30208 1.91016 9.48438 1.91016H17.3359ZM17.1602 2.75H9.66016V6.91016H10.5V6.24609C10.5 6.20703 10.513 6.17448 10.5391 6.14844C10.5781 6.10938 10.6237 6.08984 10.6758 6.08984H12.0039C12.043 6.08984 12.0755 6.10938 12.1016 6.14844C12.1406 6.17448 12.1602 6.20703 12.1602 6.24609V6.91016H17.1602V2.75Z",
      fill: "currentColor"
    }
  )
);
const SvgSections = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Sections_default = SvgSections;
